import styled from 'styled-components';

export const IconWrapper = styled.div`
  font-size: 16px;
  margin: 0px 5px;
  &:hover {
    color: #0046ff;
  }
`;

export const ToggleText = styled.span`
  display: inline-block;
  margin-left: 10px;
`;

export const Divider = styled.div`
  padding: 3px;
  border-right: 1px solid #e9edf0;
  height: 100%;
`;

export const Header = styled.div`
  font-style: italic;
  color: #979797;
`;

